import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { RolesEntityGrid } from '../features/roles/roles-entity-grid/roles-entity-grid';

export const AllRolesPage = observer(() => {
  return (
    <AppPage perm="PERM_USER_ROLE_READ" noWrapper>
      <RolesEntityGrid />
    </AppPage>
  );
});
